// https://www.regextester.com/105777
const jwtToken = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/;

export default function (str: any) {
  return jwtToken.test(str);
}
